import { fromJS } from 'immutable';
import { camelizeKeys } from 'humps';
import get from 'lodash/get';
import has from 'lodash/has';

import {
  ANSWERS__POST,
  PARTICIPANT__AUTHORIZE_IN_PREVIEW,
  PARTICIPANT__RESET,
  PARTICIPANT__USE_EMAIL,
  RESULT__INIT,
  RESULT__FETCH,
} from '../constants';

const parse = (rawParticipant) => fromJS(camelizeKeys(rawParticipant));
const defaultState = parse(get(window, 'beagly.participant') || {});

export default function (state = defaultState, action) {
  switch (action.type) {
    // case ANSWERS__POST: {
    //   // NOTE: participant is inconsistent with the rest of the app
    //   return state;
    // }
    case ANSWERS__POST:
    case RESULT__INIT:
    case RESULT__FETCH:
      if (!has(action.data, 'result.participant')) {
        return state;
      }
      return state.merge(parse(action.data.result.participant));
    case PARTICIPANT__AUTHORIZE_IN_PREVIEW:
      return state.merge(action.data);
    case PARTICIPANT__RESET:
      return state.delete('promptForEmail').delete('provider');
    case PARTICIPANT__USE_EMAIL:
      return state.set('promptForEmail', false);
    default:
      return state;
  }
}
